import * as React from 'react';
import { usePkpass } from '../usePkpass';
import { PkpassFieldsType } from '../../../../types';
import Field from './field/preview/Field';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
const useStyles = createUseStyles({
  secondaryAndAuxiliaryFields: {
    padding: ({
      theme
    }) => `${theme.scale * 10}px 0`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: ({
      theme
    }) => theme.scale * 40,
    paddingBottom: ({
      theme
    }) => theme.scale * 10,
    width: ({
      theme
    }) => theme.scale * 320
  }
});

const SecondaryAndAuxiliaryFields = () => {
  const {
    passStyle,
    pass
  } = usePkpass();
  const secondaryFields = pass[passStyle].secondaryFields || [];
  const auxiliaryFields = pass[passStyle].auxiliaryFields || [];
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.secondaryAndAuxiliaryFields
  }, secondaryFields.map((field, i) => {
    return /*#__PURE__*/React.createElement(Field, {
      key: field.key,
      fieldsType: PkpassFieldsType.SecondaryFields,
      fieldIndex: i
    });
  }), auxiliaryFields.map((field, i) => {
    return /*#__PURE__*/React.createElement(Field, {
      key: field.key,
      fieldsType: PkpassFieldsType.AuxiliaryFields,
      fieldIndex: i
    });
  }));
};

export default SecondaryAndAuxiliaryFields;
//# sourceMappingURL=SecondaryAndAuxiliaryFields.js.map